import React from 'react';
import VariablesPanel from './VariablesPanel';

const ContentLinesEditor = ({
  field,
  updateContentLine,
  toggleLineBold,
  removeContentLine,
  updateField,
  toggleVariablesPanel,
  addContentLine,
  showVariables,
  insertVariable,
  insertVariableNewLine,
}) => (
  <div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '3px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ fontWeight: 'bold', marginRight: '8px' }}>Treść:</label>
        <button
          type="button"
          onClick={() => toggleVariablesPanel(field.id)}
          style={{
            border: '1px solid var(--info)', color: 'var(--info)' , padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
          }}
        >
          Zmienne
        </button>
      </div>
      <button
        type="button"
        onClick={() => addContentLine(field.id)}
        style={{
          border: '1px solid var(--success)', color: 'var(--success)' , padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
        }}
      >
        + Linia
      </button>
    </div>

    {field.contentLines && field.contentLines.length > 0 ? (
      field.contentLines.map((line, index) => {
        const isBold = field.lineStyles?.[index]?.bold || false;
        return (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
            <input
              type="text"
              value={line}
              onChange={(e) => updateContentLine(field.id, index, e.target.value)}
              style={{
                flex: 1, padding: '4px 6px', border: '1px solid var(--border)', borderRadius: '3px',
                fontSize: '12px', marginRight: '5px', fontWeight: isBold ? 'bold' : 'normal',
              }}
              placeholder={`Linia ${index + 1} - użyj zmiennych np. {numer_faktury}`}
            />
            <button
              type="button"
              onClick={() => toggleLineBold(field.id, index)}
              style={{
                backgroundColor: isBold ? 'var(--success)' : 'var(--text-muted)', color: '#fff' , padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
                marginRight: '5px', fontWeight: 'bold',
              }}
              title={isBold ? 'Usuń pogrubienie' : 'Dodaj pogrubienie'}
            >
              B
            </button>
            {field.contentLines.length > 1 && (
              <button
                type="button"
                onClick={() => removeContentLine(field.id, index)}
                style={{
                  border: '1px solid var(--danger)', color: 'var(--danger)' , padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
                }}
              >
                &#x2715;
              </button>
            )}
          </div>
        );
      })
    ) : (
      <input
        type="text"
        value={field.content}
        onChange={(e) => updateField(field.id, { content: e.target.value })}
        style={{ width: '100%', padding: '4px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '12px' }}
        placeholder="Wpisz tekst lub użyj zmiennych np. {numer_faktury}"
      />
    )}

    {showVariables[field.id] && (
      <VariablesPanel
        fieldId={field.id}
        insertVariable={insertVariable}
        insertVariableNewLine={insertVariableNewLine}
      />
    )}
  </div>
);

export default ContentLinesEditor;
